export default __webpack_public_path__ + "static/media/AAEON.6270f9b4.png";